import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class SentryService {
  public init(): void {
    if (!Sentry.isInitialized() && environment.sentryEnable) {
      Sentry.init({
        environment: environment.sentryEnv,
        dsn: environment.sentryDns,
        integrations: integrations => {
          // Filtre les intégrations par défaut qui capturent les interactions UI
          return integrations
            .filter(integration => {
              // Désactive Breadcrumbs qui capture les clics et interfère avec Angular
              return integration.name !== 'Breadcrumbs';
            })
            .concat([
              // Ajoute l'intégration HTTP client
              Sentry.httpClientIntegration(),
              // Session Replay désactivé : même en mode "error-only", il enregistre en continu
              // en arrière-plan et interfère avec les événements Angular (notamment les onglets)
              /*Sentry.replayIntegration({
              maskAllText: false,
              blockAllMedia: false,
            }),*/
            ]);
        },

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['/api'],

        // Note: Replay désactivé car incompatible avec Angular
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.0,

        // Désactive explicitement la capture des breadcrumbs UI
        beforeBreadcrumb(breadcrumb) {
          // Ignore les breadcrumbs de type 'ui' (clics, inputs, etc.)
          if (breadcrumb.category === 'ui.click' || breadcrumb.category === 'ui.input') {
            return null;
          }
          return breadcrumb;
        },
      });
      console.info('Analytics are enabled because you have accepted analytical cookies.');
    }
  }
}
